export function setSize(data) {
  return {
    type: 'SET_SIZE',
    payload: data,
  }
}
